<template>
  <v-card>
    <v-form>
      <v-container>
        <v-layout row wrap>
          <v-flex xs12>
            <span class="mr-2">
              <v-icon color="green lighten-2" v-if="!trip[fieldData.field]">{{fieldData.iconOn}}</v-icon>
              <v-icon color="grey" v-else>{{fieldData.iconOff}}</v-icon>
            </span>
            <span class="headline">
              Update
              <!-- {{trip[fieldData.field] ? 'Unconfirm' : 'Confirm'}} -->
              <span class="grey--text subheading">- {{ fieldData.label}}</span>
            </span>
          </v-flex>
          <template v-if="fieldData.label == 'Mass Declaration'">
            <v-flex xs12 sm4>
              <v-text-field
                label="Tip / weighbridge weight"
                type="number"
                v-model.number="trip.siteWeight"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm4>
              <v-text-field
                label="Site / Load Rite weight"
                type="number"
                v-model.number="trip.tipWeight"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm4>
              <v-text-field
                label="Truck / Scale weight"
                type="number"
                v-model.number="trip.scaleWeight"
              ></v-text-field>
            </v-flex>
          </template>
          <v-flex xs12>
            <v-textarea auto-grow label="Notes" rows="2" v-model="currentNotes"></v-textarea>
          </v-flex>
          <v-flex xs12>
            <v-autocomplete label="* Status" :items="statusOptions" v-model="currentStatus"></v-autocomplete>
          </v-flex>
          <v-flex xs12>Would you like to update {{ fieldData.label}} data?</v-flex>
        </v-layout>
      </v-container>
    </v-form>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn flat @click="close()" :color="primaryGrey">No</v-btn>
      <v-btn flat @click="updateTripField()" :loading="loading" color="green darken-1">Yes</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import DocketService from "@/services/requests/docketService";
export default {
  data() {
    return {
      currentNotes: "",
      currentStatus: "",
      statusOptions: ["NOT SET", "CONFIRMED", "REVIEW"],
      loading: false
    };
  },
  methods: {
    close() {
      this.$emit("close");
    },
    updateTripField() {
      this.loading = true;
      var payload = {
        id: this.trip.id,
        field: this.fieldData.field,
        notesField: this.fieldData.notesField,
        value: this.currentStatus,
        //value: !this.trip[this.fieldData.field],
        notes: this.currentNotes,
        siteWeight: this.trip.siteWeight,
        tipWeight: this.trip.tipWeight,
        scaleWeight: this.trip.scaleWeight
      };
      DocketService.updateTripField(payload)
        .then(result => {
          this.$emit("actionComplete");
          //console.log(result);
          this.$store.commit("trips/updateArrayStateById", {
            prop: "trips",
            editedValue: result.data.result.trip
          });
          this.loading = false;
          this.snack({ color: "green", text: "Trip was updated" });
        })
        .catch(err => {
          this.snackError();
          this.loading = false;
          console.log(err);
        });
    }
  },

  props: {
    trip: Object,
    fieldData: Object,
    notes: String,
    status: String
  },
  watch: {
    notes(val) {
      this.currentNotes = val;
    },
    status(val) {
      this.currentStatus = val;
    }
  },
  mounted() {
    this.currentNotes = this.notes;
    this.currentStatus = this.status;
  }
};
</script>

<style>
</style>
